import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class HabilitationService {

    constructor() { }

    gereHabilitationChamp(resource: any, http: any, coupleCodeValeur: [string, string], model: any = null, modes: [string] = [null],
        nomChamp: string = null) {
        Observable.of(resource.call(http, 'getParametreObject', coupleCodeValeur).subscribe(data => {
            if (data === null || !data['valeur']) {
                if (model) {
                    model.registerEntryDynamicProperty(modes, nomChamp, 'hidden', true);
                    console.log('champ non affiché :', nomChamp);
                }
                return false;
            } else {
                if (model) {
                    model.registerEntryDynamicProperty(modes, nomChamp, 'hidden', false);
                    model.registerEntryDynamicProperty(modes, nomChamp, 'options', [{ label: data['valeur'] }]);
                    console.log('champ affiché avec libellé :', nomChamp, data['valeur']);
                }
                return true;
            }
        }));
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/habilitations.service.ts